import React from "react";
import { Box, Skeleton, Divider, Stack, List, ListItem, ListItemAvatar, ListItemText, Avatar, Grid,Card, CardContent } from "@mui/material";


const SkeletonCard = ({ count = 6 }) => {
  return (
    <List sx={{ width: "100%", bgcolor: "background.paper" }}>
      {[...Array(count)].map((_, index) => (

<Grid item xs={12} md={6} lg={4}>
  <Card
    sx={{
      borderRadius: 3,
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      p: 1,
    }}
  >
    <CardContent>
      {/* Top Row */}
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Skeleton variant="text" width="60%" height={32} />
        <Skeleton variant="circular" width={32} height={32} />
      </Box>

      {/* Description */}
      <Skeleton variant="text" width="100%" sx={{ mt: 2 }} />
      <Skeleton variant="text" width="90%" />
      <Skeleton variant="text" width="80%" />

      <Divider sx={{ my: 2 }} />

      {/* Subcategory Title */}
      <Skeleton variant="text" width="40%" height={28} />

      {/* Subcategory List Skeletons */}
      {[1, 2, 3].map((i) => (
        <Box
          key={i}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            padding: 1,
            mb: 1,
            backgroundColor: "#f9f9f9",
          }}
        >
          <Box sx={{ width: "80%" }}>
            <Skeleton variant="text" width="70%" height={22} />
            <Skeleton variant="text" width="90%" height={18} />
          </Box>
          <Skeleton variant="circular" width={28} height={28} />
        </Box>
      ))}
    </CardContent>
  </Card>
</Grid>))}
</List>)}


export default SkeletonCard 